import { useState } from "react";
import { CalendarDays, Droplets, Wind, ChevronDown } from "lucide-react";
import { WeatherIcon } from "./WeatherIcon";
import { temp, tempUnit, formatDay, formatDayFull, speed, speedUnit } from "../lib/weather";

export const DailyForecast = ({ daily, offset, units, accent }) => {
  const [openIdx, setOpenIdx] = useState(null);

  const allMin = Math.min(...daily.map((d) => d.temp_min));
  const allMax = Math.max(...daily.map((d) => d.temp_max));
  const range = allMax - allMin || 1;

  return (
    <div className="glass-card p-5 sm:p-6" data-testid="daily-forecast-list">
      <div className="flex items-center gap-2 mb-4">
        <CalendarDays className="w-4 h-4 text-primary" />
        <h3 className="text-base font-semibold">Prakiraan 7 Hari</h3>
      </div>

      <div className="space-y-1">
        {daily.map((d, i) => {
          const left = ((d.temp_min - allMin) / range) * 100;
          const width = ((d.temp_max - d.temp_min) / range) * 100;
          const open = openIdx === i;
          return (
            <div key={d.dt} data-testid={`daily-item-${i}`}>
              <button
                onClick={() => setOpenIdx(open ? null : i)}
                className="w-full flex items-center gap-3 py-2.5 hover:bg-secondary/40 rounded-xl px-2 transition-colors"
              >
                <span className="w-14 text-left text-sm font-semibold shrink-0">
                  {formatDay(d.dt, offset, i)}
                </span>
                <WeatherIcon icon={d.condition.icon} className="w-6 h-6 shrink-0" style={{ color: accent }} />
                <span className="flex items-center gap-0.5 text-xs text-sky-500 num w-11 shrink-0">
                  <Droplets className="w-3 h-3" />
                  {d.pop}%
                </span>
                <span className="text-sm text-muted-foreground num w-9 text-right shrink-0">
                  {temp(d.temp_min, units)}°
                </span>
                <div className="flex-1 h-1.5 rounded-full bg-secondary relative overflow-hidden min-w-[40px]">
                  <div
                    className="absolute h-full rounded-full"
                    style={{
                      left: `${left}%`,
                      width: `${Math.max(width, 8)}%`,
                      background: `linear-gradient(90deg, #38BDF8, ${accent}, #F97316)`,
                    }}
                  />
                </div>
                <span className="text-sm font-bold num w-9 text-right shrink-0">
                  {temp(d.temp_max, units)}°
                </span>
                <ChevronDown
                  className={`w-4 h-4 text-muted-foreground shrink-0 transition-transform ${open ? "rotate-180" : ""}`}
                />
              </button>
              {open && (
                <div className="px-2 pb-3 pt-1 fade-up" data-testid={`daily-detail-${i}`}>
                  <div className="glass rounded-2xl p-3 flex flex-wrap items-center gap-4 text-xs">
                    <span className="font-semibold text-muted-foreground">{formatDayFull(d.dt, offset)}</span>
                    <span className="capitalize">{d.condition.description}</span>
                    <span className="flex items-center gap-1">
                      <Wind className="w-3.5 h-3.5 text-primary" />
                      {speed(d.wind_speed, units)} {speedUnit(units)}
                    </span>
                    <span className="flex items-center gap-1">
                      <Droplets className="w-3.5 h-3.5 text-sky-500" />
                      Lembap {d.humidity}%
                    </span>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
